{
  "title": "Guiding Hand (UA)",
  "source": "Unearthed Arcana 36 - Starter Spells",
  "levelAndSchool": "1st-level divination (ritual)",
  "level": 1,
  "castingTime": "1 minute",
  "range": "5 feet",
  "components": "V, S",
  "duration": "Concentration, up to 8 hours",
  "description": [
    "You create a Tiny incorporeal hand of shimmering light in an unoccupied space you can see within range. The hand exists for the duration, but it disappears if you teleport or you travel to a different plane of existence.",
    "When the hand appears, you name one major landmark, such as a city, mountain, castle, or battlefield on the same plane of existence as you. Someone in history must have visited the site and mapped it. If the landmark appears on no map in existence, the spell fails. Otherwise, whenever you move toward the hand, it moves away from you at the same speed you moved, and it moves in the direction of the landmark, always remaining 5 feet away from you.",
    "If you don’t move toward the hand, it remains in place until you do and beckons for you to follow once every 1d4 minutes."
  ],
  "spellLists": ["bard", "cleric", "druid", "wizard"]
}
